import { createTracker } from './tracker';
import type { UserLatchInstance } from './types';

// Create the global userLatch instance
const userLatch: UserLatchInstance = createTracker();

// Expose to window for script tag usage
if (typeof window !== 'undefined') {
  (window as unknown as { userLatch: UserLatchInstance }).userLatch = userLatch;
}

export { userLatch };
export type { UserLatchConfig, UserLatchUser, UserLatchEvent, UserLatchInstance } from './types';
